namespace TabAurous.OMS {
    export interface UserRow {
        UserId?: number;
        Type?: string;
        PartyId?: number;
        CompanyId?: number;
        FinYear?: number;
        Username?: string;
        Source?: string;
        PasswordHash?: string;
        PasswordSalt?: string;
        DisplayName?: string;
        Email?: string;
        UserImage?: string;
        LastDirectoryUpdate?: string;
        IsActive?: number;
        Password?: string;
        PasswordConfirm?: string;
        HasEdit?: boolean;
        EditPassword?: string;
        HasAuth?: boolean;
        AuthPassword?: string;
        HasCatalogueAccess?: boolean;
        CatalogueAccessPassword?: string;
        ItemDiscount?: number;
        Branch?: number[];
        Department?: number[];
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace UserRow {
        export const idProperty = 'UserId';
        export const isActiveProperty = 'IsActive';
        export const nameProperty = 'Username';
        export const localTextPrefix = 'OMS.User';
        export const lookupKey = 'Administration.User';

        export function getLookup(): Q.Lookup<UserRow> {
            return Q.getLookup<UserRow>('Administration.User');
        }
        export const deletePermission = 'Administration:Security';
        export const insertPermission = 'Administration:Security';
        export const readPermission = '*';
        export const updatePermission = 'Administration:Security';

        export declare const enum Fields {
            UserId = "UserId",
            Type = "Type",
            PartyId = "PartyId",
            CompanyId = "CompanyId",
            FinYear = "FinYear",
            Username = "Username",
            Source = "Source",
            PasswordHash = "PasswordHash",
            PasswordSalt = "PasswordSalt",
            DisplayName = "DisplayName",
            Email = "Email",
            UserImage = "UserImage",
            LastDirectoryUpdate = "LastDirectoryUpdate",
            IsActive = "IsActive",
            Password = "Password",
            PasswordConfirm = "PasswordConfirm",
            HasEdit = "HasEdit",
            EditPassword = "EditPassword",
            HasAuth = "HasAuth",
            AuthPassword = "AuthPassword",
            HasCatalogueAccess = "HasCatalogueAccess",
            CatalogueAccessPassword = "CatalogueAccessPassword",
            ItemDiscount = "ItemDiscount",
            Branch = "Branch",
            Department = "Department",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
